/* eslint-disable @cspell/spellchecker */
import { riskManagerOrganization } from '../organizations';
import { getLaunchpadUsers } from './test-user-base-info';

export const devRiskManagerTestUsers = getLaunchpadUsers([
  {
    email: 'mudud@diligent.com',
    name: 'Mudud User',
    highbondId: 'a2oZDByy2s4yjwtCFs3e',
    id: 'a2oZDByy-2s4y-jwtC-Fs3e-000000000001',
    organization: riskManagerOrganization,
  },
  {
    email: 'banagy@diligent.com',
    name: 'Banagy User',
    highbondId: 'z9sHuSBxFQxvJ4-dxRij',
    id: 'z9sHuSBx-FQxv-J4dx-Rij-000000000002',
    organization: riskManagerOrganization,
  },
]);
